import React, { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import DeepThinkersList from "./DeepThinkersList";
import { request } from "../service/HttpService";

export default function DeepThinkers() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const [deepThinkers, setDeepThinkers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            request("GET", `/deepthinkers/${id}`)
                .then(res => {
                    setDeepThinkers(res.deepThinkers ?? []);
                })
                .catch(() => {})
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, [id]);

    return (
        <div className="home-layout">
            <Sidebar activePage="Submissions" />

            <main className="home-main">
                <Header />

                <div className="home-content">
                    <div className="upload-main">
                        <button className="chpw-back" onClick={() => navigate(`/submission?id=${id}`)}>
                            <ArrowLeft size={14} />
                            Back to Submission
                        </button>

                        <DeepThinkersList deepThinkers={deepThinkers} loading={loading} />
                    </div>
                </div>
            </main>
        </div>
    );
}
